import { createStore, setProp, setProps, withProps } from '@ngneat/elf';

export type CardTypeFilter = 'oa' | 'f' | 's' | 'd' | 'mi' | 'all';

export interface CardFiltersProps {
  text: string;
  tokens: string[];
  caseSensitive: boolean;
  tokenized: boolean;
  priceMin: number | null;
  priceMax: number | null;
  emptyOnNoFilter: boolean;
  cardType: CardTypeFilter; // Filter by card type
}

export const defaultFilters: CardFiltersProps = {
  caseSensitive: false,
  emptyOnNoFilter: true,
  priceMax: null,
  priceMin: null,
  text: '',
  tokenized: false,
  tokens: [],
  cardType: 'oa' // Default to OA (Oggetti Artistici)
};

export const store = createStore({ name: 'cardFilters' },
  withProps<CardFiltersProps>({ ...defaultFilters }));

export const updateText = (text: string) => store.update(setProp('text', text));
export const updateMaxPrice = (price: number | null) => store.update(setProp('priceMax', price));
export const updateMinPrice = (price: number | null) => store.update(setProp('priceMin', price));
export const updateCardType = (cardType: CardTypeFilter) => store.update(setProp('cardType', cardType));
export const updateFilters = (filters: CardFiltersProps) => store.update(setProps(filters));

export const resetFilters = () => store.update(setProps(defaultFilters));

export const cardFilters$ = store.pipe();

